/**
 * The set of input field names for the verify 2FA UI component.
 */
export var Verify2FAFormInputField;
(function (Verify2FAFormInputField) {
    Verify2FAFormInputField["CODE"] = "code";
})(Verify2FAFormInputField || (Verify2FAFormInputField = {}));
